var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDoubleBubble(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2117_1258)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.875 4.25H4.375C4.03 4.25 3.75 4.53 3.75 4.875C3.75 5.22 4.03 5.5 4.375 5.5H11.875C12.22 5.5 12.5 5.22 12.5 4.875C12.5 4.53 12.22 4.25 11.875 4.25Z",
    fill: "#756F6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.375 6.75H4.375C4.03 6.75 3.75 7.03 3.75 7.375C3.75 7.72 4.03 8 4.375 8H9.375C9.72 8 10 7.72 10 7.375C10 7.03 9.72 6.75 9.375 6.75Z",
    fill: "#756F6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.75 0.5H2.5C1.12125 0.5 0 1.62125 0 3V15.5C0 15.7425 0.14 15.9637 0.36 16.0662C0.44375 16.105 0.535 16.125 0.625 16.125C0.76875 16.125 0.91125 16.075 1.025 15.98L4.60125 13H13.75C15.1287 13 16.25 11.8787 16.25 10.5V3C16.25 1.62125 15.1287 0.5 13.75 0.5ZM15 10.5C15 11.1888 14.44 11.75 13.75 11.75H4.375C4.22875 11.75 4.0875 11.8013 3.975 11.895L1.25 14.1662V3C1.25 2.31125 1.81 1.75 2.5 1.75H13.75C14.44 1.75 15 2.31125 15 3V10.5Z",
    fill: "#756F6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5 5.5C17.155 5.5 16.875 5.78 16.875 6.125C16.875 6.47 17.155 6.75 17.5 6.75C18.19 6.75 18.75 7.31125 18.75 8V18.5737L16.64 16.8863C16.53 16.7987 16.3912 16.75 16.25 16.75H7.5C6.81 16.75 6.25 16.1888 6.25 15.5V14.875C6.25 14.53 5.97 14.25 5.625 14.25C5.28 14.25 5 14.53 5 14.875V15.5C5 16.8787 6.12125 18 7.5 18H16.03L18.9838 20.3637C19.0975 20.4537 19.2362 20.5 19.375 20.5C19.4663 20.5 19.5588 20.48 19.6462 20.4388C19.8625 20.3338 20 20.115 20 19.875V8C20 6.62125 18.8787 5.5 17.5 5.5Z",
    fill: "#756F6C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2117_1258"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleBubble);
export default __webpack_public_path__ + "static/media/DoubleBubble.50ccb256a5df7db2566ed1943b01119d.svg";
export { ForwardRef as ReactComponent };